import { render, staticRenderFns } from "./Historico_guias.vue?vue&type=template&id=338f0228"
import script from "./Historico_guias.vue?vue&type=script&lang=js"
export * from "./Historico_guias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports